export default __webpack_public_path__ + "img/Googleroadmap.png";